import React, {useContext, useEffect, useRef, useState} from 'react';
import "./changeNumberModal.css"

import ChangeNumber from "./ChangeNumber";
import CompleteChangeNumber from "./CompleteChangeNumber";
import {Context} from "../../../../../index";
import {reaction, runInAction} from 'mobx';
import {observer} from 'mobx-react-lite';

const ChangeNumberModal = observer((props) => {
    const {user, main, basket} = useContext(Context);
    const session = main.basketSession;
    const mounted = useRef(false);
    const flowRef = useRef(null);
    const resumeRef = useRef(null);
    const [flowVersion, setFlowVersion] = useState(0);
    const [stateChangeModals,setStateChangeModals] = useState(1)
    const [buttonGetCodeStatus, setButtonGetCodeStatus] = useState(2);
    const [newNumber, setNewNumber] = useState("");
    const [newNumberNoValid, setNewNumberNoValid] = useState('');
    const [smsCodeChangeNumber, setSmsCodeChangeNumber] = useState('');
    const [selectCountryUser, setSelectCountryUser] = useState(user.user?.country);

    const open = () => user.stepModals === 'changeNumber' && user.shadowOverlay === true;
    const ownerCurrent = flow => user.isAuth === true && user.user?.id === flow.owner.id;
    const ownsAuthority = flow => {
        if (!mounted.current || !flow || flowRef.current !== flow || !ownerCurrent(flow)) return false;
        // Own synchronous transition locks the old epoch before returning its
        // ticket. Never cancel that transition merely because it did its job.
        if (['starting', 'accepting', 'failing'].includes(flow.phase)) return true;
        if (flow.phase === 'pending') return session.isCurrent(flow.ticket);
        return basket.sessionEpoch === flow.epoch;
    };
    const currentFlow = flow => open() && ownsAuthority(flow);
    const resetFields = () => {
        setStateChangeModals(1); setButtonGetCodeStatus(2); setNewNumber('');
        setNewNumberNoValid(''); setSmsCodeChangeNumber(''); setSelectCountryUser(user.user?.country);
        setFlowVersion(value => value + 1);
    };
    const invalidateFlow = (allowOwnRetry = false) => {
        const old = flowRef.current;
        const knownOwner = allowOwnRetry && ownsAuthority(old) ? old.owner.id : null;
        flowRef.current = null; // Revoke before cancelAttempt can notify observers.
        session.cancelAttempt(old?.ticket);
        // Close is not logout. A known originally accepted owner may reopen this
        // same parent after cancellation, but any later epoch/owner revokes proof.
        // This permits a new credential attempt, never a basket/session grant.
        resumeRef.current = knownOwner === null ? null : {id: knownOwner, epoch: basket.sessionEpoch};
        if (mounted.current) resetFields();
    };
    const createFlow = (knownOwner, phase = 'idle') => {
        resumeRef.current = null;
        flowRef.current = {owner: Object.freeze({...knownOwner}), epoch: basket.sessionEpoch, phase, ticket: null};
        resetFields();
    };
    useEffect(() => {
        mounted.current = true;
        const stop = reaction(() => [user.isAuth, user.user?.id, user.stepModals, user.shadowOverlay,
            basket.sessionEpoch], () => {
            const flow = flowRef.current;
            if (flow && !currentFlow(flow)) invalidateFlow(!open() && ownsAuthority(flow));
            const resume = resumeRef.current;
            if (resume && (basket.sessionEpoch !== resume.epoch || user.isAuth !== true || user.user?.id !== resume.id)) {
                resumeRef.current = null;
            }
            if (!flowRef.current && open() && user.isAuth === true &&
                basket._session?.authScope === 'authenticated' && basket._session.principalId === user.user?.id) {
                createFlow(user.user);
            } else if (!flowRef.current && open() && resumeRef.current) {
                createFlow(user.user, 'failed');
            }
        }, {fireImmediately: true});
        return () => {mounted.current = false; stop(); invalidateFlow();};
    }, [user, basket, session]);
    const closeFlow = () => {invalidateFlow(true); props.closeModalChangeNumber();};
    const backToNumber = () => {
        const old = flowRef.current;
        const knownOwner = old && ownerCurrent(old) ? old.owner : null;
        invalidateFlow();
        // A cancelled own compare leaves the basket locked. The known original
        // owner may retry locally; this is not a new basket/authentication grant.
        if (knownOwner && open()) createFlow(knownOwner, basket._session ? 'idle' : 'failed');
    };
    const startCompare = flow => {
        if (!currentFlow(flow)) return null;
        flow.phase = 'starting';
        session.cancelAttempt(flow.ticket);
        try {
            flow.ticket = session.startLoginAttempt(); flow.phase = 'pending';
            return flow.ticket;
        } catch {
            flow.epoch = basket.sessionEpoch; flow.phase = 'failed';
            throw new Error('Не удалось сменить номер. Попробуйте ещё раз.');
        }
    };
    const failCompare = (flow, ticket) => {
        if (!currentFlow(flow) || flow.ticket !== ticket) return false;
        flow.phase = 'failing'; runInAction(() => session.failAuth(ticket));
        flow.ticket = null; flow.epoch = basket.sessionEpoch; flow.phase = 'failed';
        return currentFlow(flow);
    };
    const acceptCompare = (flow, ticket, principal) => {
        if (!currentFlow(flow) || flow.ticket !== ticket || principal?.id !== flow.owner.id) return false;
        flow.phase = 'accepting';
        if (!session.acceptAuth(ticket, principal)) {flow.phase = 'pending'; return false;}
        flow.owner = Object.freeze({...principal});
        flow.ticket = null; flow.epoch = basket.sessionEpoch; flow.phase = 'accepted';
        return currentFlow(flow);
    };

    const codeNumberValidator = (number) => {
        let replacenumber = number.replace(/[^\d]/g, '');
        setSmsCodeChangeNumber(replacenumber)
    }

    const clearCodeNumber = (number) => {
        setSmsCodeChangeNumber("");
    }


    return (
        <div className={"change_number_modal " + props.controllClass }>
            <ChangeNumber
                flowVersion={flowVersion}
                getFlow={() => currentFlow(flowRef.current) ? flowRef.current : null}
                currentFlow={currentFlow}
                controllClass = {stateChangeModals === 1 ? "active" : "hide" }
                goToStateTwo = {e => setStateChangeModals(2)}
                buttonStatuActive = {e => setButtonGetCodeStatus(1)}
                buttonStatuDisactive = {e => setButtonGetCodeStatus(2)}
                controllButtonClass = {buttonGetCodeStatus === 1 ? "active" : "disable"}
                newNumber={newNumber}
                setNewNumber={setNewNumber}
                newNumberNoValid={newNumberNoValid}
                setNewNumberNoValid={setNewNumberNoValid}
                SelectCountryUser={selectCountryUser}
                setSelectCountryUser={setSelectCountryUser}
                closeModalChangeNumber={closeFlow}
            />
            <CompleteChangeNumber
                flowVersion={flowVersion}
                getFlow={() => currentFlow(flowRef.current) ? flowRef.current : null}
                currentFlow={currentFlow}
                startCompare={startCompare}
                failCompare={failCompare}
                acceptCompare={acceptCompare}
                controllClass = {stateChangeModals === 2 ? "active" : "hide" }
                goToStateOne={backToNumber}
                newNumber={newNumber}
                newNumberNoValid={newNumberNoValid}
                smsCodeChangeNumber={smsCodeChangeNumber}
                SelectCountryUser={selectCountryUser}
                codeNumberValidator={e => codeNumberValidator(e.target.value)}
                controllClassConfirm={smsCodeChangeNumber.length === 4 ? "active" : "disabled"}
                clearCode={ e => clearCodeNumber("")}
                closeModalChangeNumber={closeFlow}
            />
        </div>
    );
});

export default ChangeNumberModal;
